import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';

import ValidationReferee from '../Validation/ValidationReferee';
import WizardWrapper from './WizardWrapper';
import useWizardForm from './useWizardForm';
import useRefereeReportWizard from './useRefereeReportWizard';
import Notification from '../../Notification';
import ModalConfirmation from '../../ModalConfirmation';

const WizardRefereeReport = () => {
  const {
    setValue,
    watch,
    trigger,
    formState,
    setFormState,
    setHideButtons,
    wrapperProps,
  } = useWizardForm({
    resolver: yupResolver(ValidationReferee),
  });

  const {
    userDetails,
    isAdmin,
    formStatus,
    refereeReportData,
    notificationMessage,
    notificationTitle,
    showSubmitModal,
    setShowSubmitModal,
    pendingFormData,
    sendEmailToReferee,
    setSendEmailToReferee,
    handleSubmitClick,
    handleConfirmSubmit,
    handleCancelSubmit,
    getConfirmationMessage,
  } = useRefereeReportWizard({ setValue, watch, trigger, formState, setFormState, setHideButtons });

  return (
    <>
      {notificationMessage && (
        <Notification message={notificationMessage} title={notificationTitle} />
      )}

      <WizardWrapper
        {...wrapperProps}
        activeMenu="Referee Report"
        motherMenu="Home"
        formName="referees"
        onSubmit={handleSubmitClick}
        formStatusId={formStatus}
        refereeReportData={refereeReportData}
      />

      <ModalConfirmation
        showModal={showSubmitModal}
        handleCancelSelect={handleCancelSubmit}
        bodyText={
          pendingFormData
            ? getConfirmationMessage(pendingFormData.refereeActions)
            : 'Are you sure you want to submit?'
        }
        handleConfirmSelect={handleConfirmSubmit}
        setShowModal={setShowSubmitModal}
      >
        {(pendingFormData?.refereeActions === '2' ||
          pendingFormData?.refereeActions === '4') &&
          (isAdmin || userDetails?.isMasquerade) && (
            <div className="form-check mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendEmailCheckbox"
                checked={sendEmailToReferee}
                onChange={(e) => setSendEmailToReferee(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="sendEmailCheckbox">
                Send email to referee
              </label>
            </div>
          )}
      </ModalConfirmation>
    </>
  );
};

export default WizardRefereeReport;
